<template>
    <el-select :disabled="disabled" :placeholder="placeholder" v-model="innerVal" size="small" :clearable="clearable">
        <el-option v-for="option in departmentList" :label="option.orgName" :value="option.id" :key="option.id"></el-option>
    </el-select>
</template>

<script>
export default {
    name: 'XxDepartmentSelect',
    props: {
        responseProcessor: {
            type: Function,
            default: v => v
        },
        value: {
            type: [String, Number],
            required: true,
            default: ''
        },
        // 接口名 'getSpecifiedOrgList', 'getOrgListByPoiWithAttribute'
        apiName: {
            type: String,
            default: 'getSpecifiedOrgList'
        },
        poiId: {
            type: [String, Number],
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        attribute: {
            type: [String, Number],
            default: 2
        },
        type: {
            type: [String, Number],
            default: 1
        },
        placeholder: {
            type: String,
            default: '选择部门'
        },
        setDefault: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            innerVal: this.value || '',
            departmentList: [],
            reqId: 0
        };
    },
    async created() {
        await this.fetch();
    },
    watch: {
        value() {
            this.innerVal = this.value;
        },
        poiId() {
            this.fetch();
        },
        innerVal(val) {
            this.$emit('input', val);
            this.$emit('change', val, this.departmentList.find(item => String(item.id) === String(val)));
        }
    },
    methods: {
        async fetch() {
            this.departmentList = [];
            let req = ++this.reqId;
            const ret = await this.$post(`${location.origin}/api/resource/${this.apiName}`, {
                poiId: this.poiId,
                attribute: this.attribute,
                type: this.type
            });
            if (this.reqId !== req) return;
            this.departmentList = this.responseProcessor(ret || []);
            if (this.innerVal && this.departmentList.findIndex(item => String(item.id) === String(this.innerVal)) === -1) {
                this.innerVal = '';
            }
            if (this.setDefault && !this.value) {
                this.innerVal = ret && ret[0] && ret[0].id;
            }
        }
    }
};
</script>

<style lang="scss" scoped></style>
